module.exports = __webpack_public_path__ + "img/stock3.a0f8e513.png";